import { IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { useSortBy, useTable } from "react-table";
import EditSVG from "../../../assets/svgs/edit.svg";
import DeleteSVG from "../../../assets/svgs/delete.svg";
import RecoverSVG from "../../../assets/svgs/recover.svg";
// import { ShowForPermission } from "../../shared/ShowForPermission";

import styles from "./Table.module.scss";
import HtmlTooltip from "../../shared/HtmlTooltip";
import InfoIcon from "../../icon/InfoIcon";
import ActivityLogTooltip from "../../shared/ActivityLogTooltip";

function Table({ columns, data, setSelectedResident, patientUpdated, loading, handleDelete, initialDate, isMultipleFacility, canDelete, type, handleRecover, densityMode = "comfortable", onEditPatient }) {
  const [selectedRowId, setSelectedRowId] = useState(null);

  const formatTypeLabel = (row) => {
    if (!row) return "-";
    if (row.type === "transfer" && row.transferType) {
      return String(row.transferType)
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase())
        .trim();
    }
    return String(row.type || "-").replace(/^./, (str) => str.toUpperCase());
  };

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  return (
    <div className={`${styles.tableWrpr} ${densityMode === "compact" ? styles.compactMode : ""}`} key="data-input-table-div">
      <table {...getTableProps()} key="data-input-table">
        <thead className={`ffmar fs12 ttuc`}>
          {headerGroups?.map((headerGroup, i) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={`${i}-header-row`}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}

                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? // ? " 🔽"
                        // : " 🔼"
                        " 🔽"
                        : " 🔼"
                      : ""}
                  </span>
                </th>
              ))}
              <th className={styles.actionHeader}>Actions</th>
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {!loading &&
            rows.length > 0 &&
            rows.map((row, i) => {
              prepareRow(row);
              const isRowSelected = selectedRowId === row.original?._id;
              return (
                <>
                  <tr
                    className={`ffmar fs15 ${isRowSelected ? styles.selectedRow : ""}`}
                    {...row.getRowProps()}
                    onClick={() => {
                      setSelectedRowId(row.original?._id || row.id);
                      setSelectedResident(row.original);
                    }}
                    key={`${i}-${row.id}`}
                  >
                    {row.cells.map(cell => {
                      if (cell.column.id === "type") {
                        return <td {...cell.getCellProps()}>{formatTypeLabel(row.original)}</td>;
                      }
                      return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                    })}
                    {/* <ShowForPermission type="editAdt"> */}
                    <td
                      className={`c-pointer ${styles.editBtn}`}
                    >
                      <div
                        onClick={e => {
                          e.stopPropagation();
                          onEditPatient?.(row.original);
                        }}
                        className={styles.iconAction}
                      >
                        <EditSVG fill={row?.original?.highlighter?.length > 0 ? "red" : ""} />
                      </div>
                      {isMultipleFacility ? (
                        <Tooltip title="this feature is disabled when viewing multiple facilities">
                          <div
                            className={styles.iconAction}
                            style={{ opacity: "0.5" }}
                          >
                            <DeleteSVG fill="#F93B5F" />
                          </div>
                        </Tooltip>
                      ) : (
                        type === "deleted" ? (
                          // 🆕 Show recover option if deleted type is selected
                          <Tooltip title="Recover this record">
                            <div
                              onClick={e => {
                                e.stopPropagation();
                                handleRecover(row.original._id);
                              }}
                              className={styles.iconAction}
                            >
                              <RecoverSVG fill="#4CAF50" />
                            </div>
                          </Tooltip>
                        ) : (
                          canDelete ? (
                            <div
                              onClick={e => {
                                e.stopPropagation();
                                handleDelete(row.original._id)
                              }}
                              className={styles.iconAction}
                            >
                              <DeleteSVG fill="#F93B5F" />
                            </div>
                          ) : (
                            <Tooltip title="You don’t have permission to delete this item.">
                              <div className={styles.iconAction} style={{ opacity: 0.5 }}>
                                <DeleteSVG fill="#F93B5F" />
                              </div>
                            </Tooltip>
                          )
                        )
                      )}
                      <div className={styles.iconAction}>
                        <HtmlTooltip
                          content={<ActivityLogTooltip logs={row.original?.logs ?? []} />}
                          placement="left"
                          sx={{
                            "& .MuiTooltip-tooltip": {
                              width: "360px",
                              maxWidth: "360px",
                              padding: 0,
                            },
                          }}
                        >
                          <IconButton disableFocusRipple={true} disableRipple={true}>
                            <InfoIcon viewBox="0 0 11 11" />
                          </IconButton>
                        </HtmlTooltip>
                      </div>
                    </td>
                    {/* </ShowForPermission> */}
                  </tr>
                  <tr className={styles.separatorTr} key={"separator " + i}></tr>
                </>
              );
            })}
        </tbody>
      </table>

      {!loading && rows.length === 0 && (
        <div className={styles.noRecordOverlay}>
          <div>
            <div className={styles.noRecordText}>No records found</div>
            <div className={styles.noRecordSubText}>Try changing search or date filters.</div>
          </div>
        </div>
      )}

    </div>
  );
}

export default Table;
